<script>
import MyCustomComp from '../src/components/MyCustomComp.vue';
export default {
  name: 'ExternalApi4731de8e',
  components: {
    MyCustomComp: MyCustomComp
  },
  frontmatter: JSON.parse('{"componentName":"ExternalApi4731de8e"}')
};
</script>

<template>
  <div>
    <h2 style="color: DarkViolet;">External API - custom code block</h2>
<p>Check out the demo below:</p>
<p>frontmatter: {{ $options.frontmatter }}</p>
<p>THIS LINE OF TEXT WILL BE BECOME UPPERCASES</p>
  </div>
</template>


